import React, { useState } from "react";
import {
  Container,
  Paper,
  Text,
  Button,
  Group,
  Stack,
  LoadingOverlay,
  Alert,
} from "@mantine/core";
import { IconAlertCircle, IconCalendar } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useResponsive } from "../../context/ResponsiveContext";
import { useCheckoutStatus } from "../../hooks/useCheckoutStatus";
import { TIER_CONFIG } from "../../types/featureAccess";

function SubscriptionPrompt() {
  const [isLoading] = useState(false);
  const { message, messageType } = useCheckoutStatus();
  const { isMobile } = useResponsive();
  const navigate = useNavigate();

  const handleViewOptions = () => {
    navigate("/admin/settings/subscription");
  };

  return (
    <Stack>
      <LoadingOverlay visible={isLoading} />
      <Container p="0" w="100%">
        <Paper radius="md" p="lg" withBorder>
          {message && (
            <Alert
              icon={<IconAlertCircle size={16} />}
              title={messageType === "success" ? "Success!" : "Checkout Status"}
              color={messageType === "success" ? "green" : "blue"}
              mb="md"
            >
              {message}
            </Alert>
          )}
          <Stack gap="lg">
            <Group>
              <IconCalendar
                size={isMobile ? 32 : 48}
                color="var(--brand-burnt-orange)"
              />
              <Stack gap="0">
                <Text fw={500} size={isMobile ? "lg" : "xl"}>
                  Pagoda Labs - Booking Platform Access
                </Text>
                <Text size={isMobile ? "lg" : "xl"} fw={500} c="teal">
                  {TIER_CONFIG.trial.trialDays} days free
                </Text>
              </Stack>
            </Group>
            <Stack gap={4}>
              <Text size="md" fw={500}>
                Enjoying your free trial? Finalize your subscription today by
                clicking the button below.
              </Text>
              <Text size="md" fw={500}>
                If you provide your details prior to the{" "}
                {TIER_CONFIG.trial.trialDays}-day free trial, you will not be
                charged until the trial period is over.
              </Text>
            </Stack>

            <Stack gap="md">
              <Button
                onClick={handleViewOptions}
                size="lg"
                color="teal"
                fullWidth
              >
                View Subscription Options
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Container>
    </Stack>
  );
}

export default SubscriptionPrompt;
